import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import './stylesheet/homePage.css';
import { send_request } from '../../utils/Request';
import FadeIn from 'react-fade-in';
import ActionsUsedCard from './HomePageComponents/ActionsUsedCard';
import AiCreditsCard from './HomePageComponents/AiCreditsCard';
import AgentCardsSection from './HomePageComponents/AgentCardsSection';
import RecentConversationsCard from './HomePageComponents/RecentConversationsCard';
import RecentWorkflowsCompactCard from './HomePageComponents/RecentWorkflowsCompactCard';
import TaskSummaryCardV2 from './HomePageComponents/TaskSummaryCardV2';
import PageLayout from '../common/PageLayout';

export default function HomePage() {
  const [displayName, setDisplayName] = useState('');
  const [tier, setTier] = useState('');
  const [roleAdministrator, setRoleAdministrator] = useState(false);
  const [roleEditor, setRoleEditor] = useState(false);
  const [rolePrivateViewer, setRolePrivateViewer] = useState(false);
  const [agents, setAgents] = useState([]);
  const [agentsLoading, setAgentsLoading] = useState(true);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const json = await send_request('authz-service/user-info', '', {});
        if (json?.data) {
          setDisplayName(json.data.displayName);
          setTier(json.data.client?.tier);
          setRoleAdministrator(json.data.roleAdministrator);
          setRoleEditor(json.data.roleEditor);
          setRolePrivateViewer(json.data.rolePrivateViewer);
        }
      } catch (e) {
        console.error('Error fetching user info:', e);
      }
    };

    const fetchAgents = async () => {
      try {
        const response = await send_request('project-service/agent/list', '', {}, 'GET');
        setAgents(response?.data || []);
      } catch (e) {
        console.error('Error fetching agents:', e);
      } finally {
        setAgentsLoading(false);
      }
    };

    fetchUserInfo();
    fetchAgents();
  }, []);

  return (
    <PageLayout title={`Hello ${displayName}`}>
      <FadeIn transitionDuration="1000">
        {!roleAdministrator && !roleEditor && rolePrivateViewer ? (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TaskSummaryCardV2 />
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={3}>
            {/* Full-width agent cards hero */}
            <Grid item xs={12}>
              <AgentCardsSection agents={agents} loading={agentsLoading} />
            </Grid>

            {/* Two-column body */}
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <RecentConversationsCard agents={agents} />
                </Grid>
                <Grid item xs={12}>
                  <TaskSummaryCardV2 />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={4}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <ActionsUsedCard tier={tier} />
                </Grid>
                <Grid item xs={12}>
                  <AiCreditsCard tier={tier} />
                </Grid>
                <Grid item xs={12}>
                  <RecentWorkflowsCompactCard />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </FadeIn>
    </PageLayout>
  );
}
